import useSWR from 'swr'
import axios from '../../../lib/httpClient'

function sortCart(cart) {
  cart.contents?.sort((a, b) => {
    if (a?.expires_at_timestamp && !b?.expires_at_timestamp) {
      return -1
    }
    if (!a?.expires_at_timestamp && b?.expires_at_timestamp) {
      return 1
    }
    if (a?.expires_at_timestamp && b?.expires_at_timestamp) {
      return a.expires_at_timestamp - b.expires_at_timestamp
    }
    return 0
  })
  return cart
}

export default function useCart() {
  const fetchCart = () => {
    const uuid = window.localStorage.getItem('cart')
    if (!uuid) { return null }

    return axios.get(`/api/cart/${uuid}`)
      .then((response) => response.data.cart)
      .then((cart) => sortCart(cart))
      .catch((error) => {
        if (error.response?.status === 404 || error.response?.status === 403) {
          window.localStorage.removeItem('cart')
        }
        throw error
      })
  }

  const {
    data: cart, isLoading, isError, mutate,
  } = useSWR('cart', fetchCart, { revalidateOnFocus: true })

  return {
    cart, isLoading, isError, mutate,
  }
}
